import numeral from "numeral";
import { useState } from "react";
import { useInsuranceStore } from "../../../_store/insuranceStore";
import { CardMain } from "../../../components/card/CardMain";
import NumbericValidateRed from "../../../components/DebtBalance/numericRed";
import { HeadtitleCard } from "../../../components/header/Header";
import { defaultValue } from "../../../functions/main";
import { ICON_ARROW_UP_DOWN } from "../../../utils/useIcons";
import { STYLE_INPUT, STYLE_PADDING_MAIN } from "../../../utils/useStyle";

const ViewDisable_StepTwo = ({ onChangeForm, insuranceData }) => {
  const [isOpen, setIsOpen] = useState(true);
  // const insuranceData = useInsuranceStore((state) => state.insuranceData);

  // Calculate the sum of disabled personal expenses
  const calculateSumDisabledPersonalExpenses = () => {
    const saving =
      parseFloat(insuranceData?.disabled_personal_expenses_saving) || 0;
    const tax = parseFloat(insuranceData?.disabled_personal_expenses_tax) || 0;
    const lifeFund =
      parseFloat(insuranceData?.disabled_personal_expenses_life_fund) || 0;
    const socialInsurance =
      parseFloat(insuranceData?.disabled_personal_expenses_social_insurance) ||
      0;


    if (
      (insuranceData?.sum_disabled_income <
      (saving + tax + lifeFund + socialInsurance))
    ) {
      return tax + lifeFund + socialInsurance;
    }

    return saving + tax + lifeFund + socialInsurance;
  };


  return (
    <div>
      <div className={`${STYLE_PADDING_MAIN} my-3 space-y-5 `}>
        <CardMain
          title={"คำนวณรายรับ"}
          panel={
            <div>
              <div className=" px-3 space-y-1">
                <div className=" font-semibold text-maincyan text-center text-xl">
                  {numeral(insuranceData.sum_disabled_family_expenses).format(
                    "0,0"
                  )}{" "}
                  บาท
                </div>
                <div className=" text-mainblue text-center text-sm font-medium">
                  รายรับคงเหลือตอนท่านยังเป็นปกติ
                </div>
              </div>
              <div className=" border-b border-gray60 w-full my-2.5"></div>
              <div
                onClick={() => setIsOpen(!isOpen)}
                className=" flex justify-center items-center gap-1 text-xs text-maingray font-medium"
              >
                รายละเอียด
                <ICON_ARROW_UP_DOWN
                  className={` ${
                    isOpen ? "rotate-180" : ""
                  } w-4 h-4 transition-all`}
                />
              </div>
              {isOpen && (
                <div className=" my-4">
                  <div className=" text-sm text-center  px-3 mb-2.5 ">
                    หากทุพพลภาพค่าใช้จ่ายที่จะไม่เกิดขึ้น ได้แก่  
                  </div>
                  <div className=" space-y-2.5">
                    <HeadtitleCard title="เงินออมทั้งปี" />
                    <div className=" px-3">
                      <NumbericValidateRed
                        maxLength={11}
                        placeholder="xx,xxx"
                        thousandSeparator=","
                        inputMode="decimal"
                        pattern="[0-9],*"
                        className={`${STYLE_INPUT} `}
                        onChange={onChangeForm(
                          "disabled_personal_expenses_saving"
                        )}
                        value={insuranceData?.disabled_personal_expenses_saving}
                      />
                    </div>
                    <HeadtitleCard title="ภาษีเงินได้" />
                    <div className=" px-3">
                      <NumbericValidateRed
                        maxLength={11}
                        placeholder="xx,xxx"
                        thousandSeparator=","
                        inputMode="decimal"
                        pattern="[0-9],*"
                        className={`${STYLE_INPUT} `}
                        onChange={onChangeForm(
                          "disabled_personal_expenses_tax"
                        )}
                        value={insuranceData?.disabled_personal_expenses_tax}
                      />
                    </div>
                    <HeadtitleCard title="กองทุนสำรองเลี้ยงชีพทั้งปี" />
                    <div className=" px-3">
                      <NumbericValidateRed
                        maxLength={11}
                        placeholder="xx,xxx"
                        thousandSeparator=","
                        inputMode="decimal"
                        pattern="[0-9],*"
                        className={`${STYLE_INPUT} `}
                        onChange={onChangeForm(
                          "disabled_personal_expenses_life_fund"
                        )}
                        value={
                          insuranceData?.disabled_personal_expenses_life_fund
                        }
                      />
                    </div>
                    <HeadtitleCard title="เงินประกันสังคมทั้งปี" />
                    <div className=" px-3">
                      <NumbericValidateRed
                        maxLength={11}
                        placeholder="xx,xxx"
                        thousandSeparator=","
                        inputMode="decimal"
                        pattern="[0-9],*"
                        className={`${STYLE_INPUT} `}
                        onChange={onChangeForm(
                          "disabled_personal_expenses_social_insurance"
                        )}
                        value={
                          insuranceData?.disabled_personal_expenses_social_insurance
                        }
                      />
                    </div>
                  </div>
                  <div className=" text-center mt-4 font-medium">
                    รวมค่าใช้จ่ายที่จะไม่เกิดขึ้นหลังทุพพลภาพ
                    <div className=" text-mainblue font-semibold text-xl">
                      {numeral(calculateSumDisabledPersonalExpenses()).format(
                        "0,0"
                      )}{" "}
                      บาท
                    </div>
                  </div>
                  <div className="border-b border-mainyellow w-full my-2.5"></div>
                  <div className=" text-center mt-4">
                    <div className=" text-mainblue font-semibold text-xl">
                      รายรับคงเหลือตอนท่านยังเป็นปกติ
                    </div>
                    <div className=" text-maincyan font-semibold text-2xl">
                      {numeral(
                        insuranceData.sum_disabled_family_expenses
                      ).format("0,0")}{" "}
                      บาท
                    </div>
                  </div>
                </div>
              )}
            </div>
          }
        />
      </div>
    </div>
  );
};

export default ViewDisable_StepTwo;
